import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, userId: Number }

  async open() {
    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ user_id: this.userIdValue })
      })
      
      const data = await response.json()
      window.open(data.url, '_blank')
    } catch (error) {
      console.error('Error:', error)
    }
  }
}